import * as Scrivito from "scrivito";
import sectionWidgetIcon from "../../assets/images/section_widget.svg";

Scrivito.provideEditingConfig("SectionContentWidget", {
  title: "Section",
  thumbnail: sectionWidgetIcon,
  attributes: {
    backgroundColor: {
      title: "Background color",
      description:
        "Does not apply if a background image is set. Default: White",
      values: [
        { value: "bg-white", title: "White" },
        { value: "bg-light-gray", title: "Light grey" },
        { value: "bg-lighter-gray", title: "Lighter grey" },
      ],
    },
    useFullWidth: {
      title: "Use full width?",
      description: "Default: No",
      values: [
        { value: "yes", title: "Yes" },
        { value: "no", title: "No" },
      ],
    },
    padding: {
      title: "Show padding?",
      description: "Padding adds space around this section. Default: Yes",
      values: [
        { value: "py-0", title: "none" },
        { value: "py-1", title: "very-small" },
        { value: "py-2", title: "small" },
        { value: "py-3", title: "default" },
        { value: "py-4", title: "large" },
        { value: "py-5", title: "extra-large" },
      ],
    },
  },
  properties: [
    "backgroundColor",
    "background",
    "useFullWidth",
    "padding",
    "largeTopPadding",
  ],
  initialContent: {
    backgroundColor: "white",
    padding: "py-3",
    useFullWidth: "no",
  },
});
